import React from 'react'
import { Typography,Link } from '@material-ui/core';

  
export const Footer = () => {
    return (
        <div>
          <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://www.gsb.or.th/">
        GSB
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>   
        </div>
    )
}
